import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Typography } from "@mui/material";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import { MapContext } from "../../store/context";
import { GetBlockData } from "./Tools/GetBlockData";
import { MapDrawerOpen } from "../../atom/atom";
import { useRecoilState } from "recoil";

export const MapMenuContext = React.createContext({});

export function MapMenu() {
  const [anchorPt, setAnchorPt] = React.useState({});
  const [mapClickEvent, setMapClickEvent] = React.useState(null);
  const [drawerOpen, setDrawerOpen] = useRecoilState(MapDrawerOpen);
  const openMenu = Object.keys(anchorPt).length === 2;
  const ctx = React.useContext(MapContext);

  const handleClick = () => {
    setAnchorPt({});
  };

  const openSidebar = () => {
    setAnchorPt({});
    setDrawerOpen(true);
  };

  React.useEffect(() => {
    if (ctx.map) {
      ctx.map.on("contextmenu", (e) => {
        const mapElement = document.getElementsByClassName("map-container");
        const mapPosition = mapElement[0].getBoundingClientRect();
        setAnchorPt({
          left: Math.round(mapPosition.x + e.point.x),
          top: Math.round(mapPosition.y + e.point.y),
        });
        setMapClickEvent(e);
      });
    }
  }, [ctx.map]);

  return (
    <MapMenuContext.Provider
      value={{
        anchorPt: anchorPt,
        mapClickEvent: mapClickEvent,
        setAnchorPt: setAnchorPt,
        setMapClickEvent: setMapClickEvent,
      }}
    >
      <Menu
        id="basic-menu"
        open={openMenu}
        onClose={handleClick}
        anchorReference="anchorPosition"
        anchorPosition={anchorPt}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{ bottom: "0px", right: "0px", zIndex: 1001 }}
      >
        <GetBlockData />
        <MenuItem disabled={drawerOpen} onClick={openSidebar}>
          <ListItemIcon>
            <TableChartOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body2">Open sidebar</Typography>
          </ListItemText>
        </MenuItem>
      </Menu>
    </MapMenuContext.Provider>
  );
}
